import RenderHfProfile from "components/settings/update-hf-profile";
import React from "react";

export default function UpdateHfProfile() {
  return <RenderHfProfile />;
}
